import React, { useState } from 'react';

import { ArrowRight } from 'lucide-react';

import AJAX from 'common/AJAX';
import { CompanyContext } from 'common/containers/CompanyContainer';
import { cn } from 'common/style/utils';
import VStack from 'common/ui/VStack';
import Button from 'common/uiV3/Button/Button';
import withContexts from 'common/util/withContexts';

type Props = {
  company?: {
    nux?: Record<string, boolean>;
  };
  name: string;
  title: string;
  subtitle: string;
  buttonText: string;
  buttonHref: string;
  className?: string;
  onButtonClick?: () => void;
};

const DismissableTip = ({
  company,
  name,
  title,
  subtitle,
  buttonText,
  buttonHref,
  className,
  onButtonClick,
}: Props) => {
  const [isDismissed, setIsDismissed] = useState(company?.nux?.[name] || false);

  const onDismiss = () => {
    setIsDismissed(true);
    AJAX.post('/api/nux/dismissNUX', {
      nuxType: name,
    });
  };

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }
  };

  if (isDismissed) {
    return null;
  }

  return (
    <div className={cn('p-4 text-sm text-foreground base-border rounded-md box-border', className)}>
      <VStack className="gap-2">
        <p className="text-base font-semibold">{title}</p>
        <p className="text-muted-foreground">{subtitle}</p>
        <div className="flex flex-row flex-wrap gap-2">
          <Button onClick={handleButtonClick} asChild size="small">
            <a href={buttonHref} rel="noopener nofollow" target="_blank">
              {buttonText} <ArrowRight />
            </a>
          </Button>
          <Button variant="outlined" onClick={onDismiss} size="small">
            Dismiss
          </Button>
        </div>
      </VStack>
    </div>
  );
};

export default withContexts(
  {
    company: CompanyContext,
  },
  {
    forwardRef: true,
  },
)(DismissableTip);
